import React, { Component, forwardRef } from 'react';
import composeRefs from './composeRefs';
export default function rerenderHOC(ComposedComponent) {
    class Rerenderer extends Component {
        state = this.props.props;
        render() {
            const ref = composeRefs(this.props.forwardedRef);
            return (<ComposedComponent {...this.state} ref={instance => ref(instance != null ? { ...instance, rerender: this.setState.bind(this) } : null)}/>);
        }
    }
    return forwardRef(function RerendererForwardRef(props, ref) {
        return <Rerenderer props={props} forwardedRef={ref}/>;
    });
}
